export default "__VITE_ASSET__aXorulR5__"